import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

let UiCDashboardHeaderService = class UiCDashboardHeaderService {
    constructor() { }
};
UiCDashboardHeaderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCDashboardHeaderService_Factory() { return new UiCDashboardHeaderService(); }, token: UiCDashboardHeaderService, providedIn: "root" });
UiCDashboardHeaderService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], UiCDashboardHeaderService);

let UiCDashboardHeaderComponent = class UiCDashboardHeaderComponent {
    constructor(router) {
        this.router = router;
        this.grid = new EventEmitter();
        this.FlagActive = new EventEmitter();
        this.FlagActiveNotification = new EventEmitter();
    }
    ngOnInit() { }
    onFlagActiveNotification() {
        this.FlagActiveNotification.emit();
    }
    onFlagActive() {
        this.FlagActive.emit();
    }
    iconGrid() {
        this.grid.emit();
    }
    goToHome() {
        this.router.navigate(['/app/dashboard']);
    }
};
UiCDashboardHeaderComponent.ctorParameters = () => [
    { type: Router }
];
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "userName", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "flagGrid", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "brand", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "nameInitials", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "FlagActiveBtn", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "userCompleteName", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "iconImg", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "FlagActiveNotificationBtn", void 0);
__decorate([
    Input()
], UiCDashboardHeaderComponent.prototype, "isMenuApplication", void 0);
__decorate([
    Output()
], UiCDashboardHeaderComponent.prototype, "search", void 0);
__decorate([
    Output()
], UiCDashboardHeaderComponent.prototype, "grid", void 0);
__decorate([
    Output()
], UiCDashboardHeaderComponent.prototype, "FlagActive", void 0);
__decorate([
    Output()
], UiCDashboardHeaderComponent.prototype, "FlagActiveNotification", void 0);
UiCDashboardHeaderComponent = __decorate([
    Component({
        selector: 'ui-c-dashboard-header',
        template: "<div class=\"dashboard-header\">\n  <ion-header>\n    <ion-toolbar class=\"container\">\n      <ion-row class=\"row-principal\">\n        <ion-col size=\"6\" class=\"ion-padding-horizontal\">\n          <ion-row class=\"search-row\">\n            <ion-col size=\"4\" class=\"ion-no-padding\" (click)=\"goToHome()\">\n              <ion-img class=\"ion-img\" [src]=\"brand\"> </ion-img>\n            </ion-col>\n            <ion-col size=\"6\" class=\"ion-no-padding\">\n              <ion-searchbar placeholder=\"Pesquisar\" *ngIf=\"false\"></ion-searchbar>\n            </ion-col>\n          </ion-row>\n        </ion-col>\n        <ion-col size=\"6\" class=\"ion-padding-horizontal icon-col\">\n          <ion-row class=\"ion-justify-content-end ion-align-items-center\">\n            <ion-col size=\"2\" class=\"ion-no-padding text-center\" *ngIf=\"false\">\n              <ion-button (click)=\"onFlagActiveNotification()\"\n                [ngClass]=\"FlagActiveNotificationBtn ? 'user-btn' : 'user-btn-off'\" class=\"btn-notification\">\n                <ion-icon class=\"font-size-27\" name=\"notifications-outline\"></ion-icon>\n              </ion-button>\n            </ion-col>\n            <ion-col size=\"2\" class=\"user-col ion-no-padding text-center\">\n              <ion-button (click)=\"onFlagActive()\" [ngClass]=\"FlagActiveBtn ? 'user-btn' : 'user-btn-off'\">\n                <p id=\"username-icon\" class=\"text-center font-weight-bold\">{{ nameInitials }}</p>\n                <p class=\"user-name\">{{ userName }}</p>\n              </ion-button>\n            </ion-col>\n            <ion-col size=\"2\" class=\"ion-no-padding\" *ngIf=\"isMenuApplication\">\n              <ion-button (click)=\"iconGrid()\" [ngClass]=\"flagGrid ? 'user-btn' : 'user-btn-off'\"\n                class=\"btn-notification\">\n                <ion-img class=\"font-size-35\" [src]=\"iconImg\"></ion-img>\n              </ion-button>\n            </ion-col>\n          </ion-row>\n        </ion-col>\n      </ion-row>\n    </ion-toolbar>\n  </ion-header>\n</div>\n",
        styles: [""]
    })
], UiCDashboardHeaderComponent);

let UiCDashboardHeaderModule = class UiCDashboardHeaderModule {
};
UiCDashboardHeaderModule = __decorate([
    NgModule({
        declarations: [UiCDashboardHeaderComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            RouterModule,
        ],
        exports: [
            UiCDashboardHeaderComponent
        ]
    })
], UiCDashboardHeaderModule);

/*
 * Public API Surface of ui-c-dashboard-header
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCDashboardHeaderComponent, UiCDashboardHeaderModule, UiCDashboardHeaderService };
//# sourceMappingURL=wlp-ui-c-dashboard-header.js.map
